module.exports = __webpack_public_path__ + "static/wordpress-f87eebaaf15ca447fae340d7f4d25d9f.png";